import React from 'react';
import { pdf, Font, Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import cl from './Contract.module.css'
import PDFicon from "../../../../assets/Icon/SheildCheck";
import HelveticaBold from '../../../../assets/Fonts/HelveticaNeueLTGEOW82-75Bd.ttf'; 
import HelveticaRd from '../../../../assets/Fonts/HelveticaNeueLTGEOW82-55Rm.ttf';  
import { useTranslation } from 'react-i18next';
  
  
 

Font.register({
    family: 'HelveticaRd',  
    src: HelveticaRd, 
});

Font.register({
    family: 'HelveticaBold', 
    src: HelveticaBold, 
});



const styles = StyleSheet.create({

    page: {
        fontFamily: 'HelveticaRd', 
        backgroundColor: '#FFF',
        padding: '40px 50px',
        fontSize: '10px',
        lineHeight: 1.5, 
        textAlign: 'justify',
    }, 
    
    p: { 
        marginBottom: '10px',
        textAlign: 'justify',
    }, 
    p0: { 
        marginBottom: '0px',
        textAlign: 'justify',
    }, 
    b: { 
        fontFamily: 'HelveticaBold', 
    }, 

});

 


const MyDocument = ({ car }) => (
    <Document>

        <Page size="A4" style={styles.page}>
 
            <View style={{fontFamily: 'HelveticaBold', textAlign: 'right', marginBottom: '5px',}}>
                <Text>დანართი N1</Text> 
            </View>
 
            <View style={{fontFamily: 'HelveticaBold', textAlign: 'center', marginBottom: '5px', marginTop: '20px'}}>
                <Text>ავტომობილის დაზღვევის პირობები</Text> 
            </View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>1.</Text><Text style={{textAlign: 'justify', }}>სადაზღვევო პირობები, ვრცელდება იმ გარეგნულ მდგომარეობაზე, რაც ასახულია ტრანსპორტირების დაწყების მომენტში გადაღებულ ფოტოებზე.</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>2.</Text><Text style={{textAlign: 'justify', }}>ზარალის განხილვა ხდება, ტრანსპორტირების დაწყებისას და მიმღებ პორტში კომპანიის წარმომადგენლის მიერ გადაღებული  ფოტოების შედარებით.</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>3.</Text><Text style={{textAlign: 'justify', }}>თუ დეტალი ექვემდებარება აღდგენას, ასეთ შემთხვევაში დაზიანების ანაზღაურება მოხდება მისი აღდგენისათვის საჭირო ოდენობით.</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>4.</Text><Text style={{textAlign: 'justify', }}>როდესაც დაზიანებული დეტალი არ ექვემდებარება აღდგენას, ზარალი ანაზღაურდება არაორიგინალი დეტალის ღირებულებით.</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>5.</Text><Text style={{textAlign: 'justify', }}>სავალდებულო ფრანშიზა განისაზღვრება ზარალის 5%, მინიმუმ 100 აშშ დოლარით.</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>6.</Text><Text style={{textAlign: 'justify', }}>ზარალი განიხილება გონივრულ ვადაში, არა უმეტეს ერთი თვისა.</Text></View>
            
            
            <View style={{fontFamily: 'HelveticaBold', textAlign: 'center', marginBottom: '5px', marginTop: '20px'}}>
                <Text>ანაზღაურებას ექვემდებარება ავტომობილის შემდეგი დაზიანებები:</Text> 
            </View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>1.</Text><Text style={{textAlign: 'justify', }}>ბამპერი</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>2.</Text><Text style={{textAlign: 'justify', }}>ცხაური</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>3.</Text><Text style={{textAlign: 'justify', }}>ფრთა</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>4.</Text><Text style={{textAlign: 'justify', }}>სახურავი</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>5.</Text><Text style={{textAlign: 'justify', }}>საყრდენი ძელი ე.წ. სტოიკა</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>6.</Text><Text style={{textAlign: 'justify', }}>საქარე მინა</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>7.</Text><Text style={{textAlign: 'justify', }}>სარკე</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>8.</Text><Text style={{textAlign: 'justify', }}>კარი</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>9.</Text><Text style={{textAlign: 'justify', }}>ფარი</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>10.</Text><Text style={{textAlign: 'justify', }}>უკანა მაშუქი ე.წ. სტოპი</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>11.</Text><Text style={{textAlign: 'justify', }}>საბარგული</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 20, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>12.</Text><Text style={{textAlign: 'justify', }}>ავტომობილის ძარის სხვა შემადგენელი დეტალები</Text></View>
                                                                                                                    
            
            <View style={{fontFamily: 'HelveticaBold', textAlign: 'center', marginBottom: '5px', marginTop: '20px'}}>
                <Text>ანაზღაურებას არ ექვემდებარება ავტომობილის შემდეგი დაზიანებები:</Text> 
            </View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>1.</Text><Text style={{textAlign: 'justify', }}>როცა დაზიანებულ დეტალს ემატება დაზიანება</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>2.</Text><Text style={{textAlign: 'justify', }}>ავტომობილის ტექნიკური გაუმართაობა</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>3.</Text><Text style={{textAlign: 'justify', }}>აკუმულიატორი</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>4.</Text><Text style={{textAlign: 'justify', }}>დანესტიანებული სალონის ქიმწმენდა, დაზიანებული სალონი</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>5.</Text><Text style={{textAlign: 'justify', }}>დაზიანება, რომლის აღმოფხვრა შესაძლებელია პოლირებით</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>6.</Text><Text style={{textAlign: 'justify', }}>ნაწილები და დეტალები, რომელიც მდებარეობს ძრავში, სალონში.მანქანის ქვედა მხარეს, ძირი, საბურავები, დისკები, ამორტიზატორები და სხვა სავალი ნაწილები</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>7.</Text><Text style={{textAlign: 'justify', }}>დეტალები, რომლებიც არ ჩანს ვიზუალურად ფოტოებზე</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>8.</Text><Text style={{textAlign: 'justify', }}>მოტოციკლის , კვადროციკლების , თოვლის ყველგანმავლების დეტალები, პლასმასები</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>9.</Text><Text style={{textAlign: 'justify', }}>დეტალები, რომლებიც არ არის ქარხნული წესით დამაგრებული, დაზიანების შედეგად ნახევრად მიმაგრებულია ან გარკვეულ წილად დაზიანებულია დამაგრების ადგილები ან თავად დეტალები</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>10.</Text><Text style={{textAlign: 'justify', }}>ევაკუატორის მომსახურება და სხვა ხარჯები, რომელიც უკავშირდება გასაღების დაკარგვას</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>11.</Text><Text style={{textAlign: 'justify', }}>საბარგულის და სალონის ნოხები, რეზინის საფარები</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 30, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>12.</Text><Text style={{textAlign: 'justify', }}>ნაკაწრები</Text></View>
                                                                                                                    
            
            <View style={{fontFamily: 'HelveticaBold', textAlign: 'center', marginBottom: '20px', marginTop: '20px'}}>
                <Text>გამონაკლისები:</Text> 
            </View>
         
  
            <Text style={styles.p}>
                არც ერთ შემთხვევაში ეს დაზღვევა არ ფარავს დანაკარგს, დაზიანებას ან ხარჯს, გამოწვეულს ნებისმიერი საომარი იარაღის გამოყენებით, რომელიც მოიცავს ატომური ან ბირთვული დაშლის და/ან სინთეზის ან სხვა მსგავს რეაქციას ან რადიოაქტიურ ნივთიერებას ან გამოსხივებას
            </Text> 
      
  
            <Text style={styles.p}>
                არც ერთ შემთხვევაში ეს დაზღვევა არ ფარავს დანაკარგს, დაზიანებას ან ხარჯს, გამოწვეულს შეპყრობით, კონფისკაციით, ყადაღით, გადაადგილების აკრძალვით ან დაკავებით (გარდა მეკობრეობისა) და მათგან გამომდინარე შედეგებით ან ამ ქმედებების ნებისმიერი მცდელობით.
            </Text> 
  
            <Text style={styles.p}>
                არც ერთ შემთხვევაში ეს დაზღვევა არ ფარავს დანაკარგს, დაზიანებას ან ხარჯს, გამოწვეულს მიტოვებული ნაღმებით, ტორპედოებით, ბომბებით ან სხვა მიტოვებული საომარი იარაღით.
            </Text> 
      
  
            <Text style={styles.p}>
                არც ერთ შემთხვევაში ეს დაზღვევა არ ფარავს დანაკარგს, დაზიანებას ან ხარჯს:
            </Text> 
  
            <Text style={styles.p}>
                გამოწვეულს გაფიცულთა ქმედებებით, ლოკაუტირებული მუშებით, ან იმ პიროვნებების ქმედებით, რომლებიც იღებენ მონაწილეობას შრომით არეულობებში, აჯანყებაში ან სამოქალაქო მღელვარებაში.
            </Text> 
       
            <Text style={styles.p}>
                გამოწვეულს გაფიცვებით, ლოკაუტით, შრომითი არეულობით, აჯანყებით ან სამოქალაქო მღელვარებით.
            </Text> 
       
            <Text style={styles.p}>
                გამოწვეულს ნებისმიერი ტერორისტული ან პოლიტიკური მოტივით მოქმედი პიროვნების/ების მიერ.
            </Text> 
      
  
            <Text style={styles.p}>
                არც ერთ შემთხვევაში ეს დაზღვევა არ დაფარავს დანაკარგს, დაზიანებას ან ხარჯს, გამოწვეულს გემის ან ხომალდის ნაოსნობისთვის გამოუსადეგარობით,
            </Text> 
      
  
            <Text style={styles.p}>
                გემის, ხომალდის, გადაზიდვის სხვა საშუალების, კონტეინერის ან სატვირთო ვაგონის შეუსაბამობით დაზღვეული ტვირთის უსაფრთხო გადაზიდვასთან.
            </Text> 
      
  
            <Text style={styles.p}>
                იმ შემთხვევაში, როცა დაზღვეული ტვირთის მათში ჩატვირთვის დროისათვის დაზღვეულისათვის ან მისი მომსახურე პერსონალისათვის ცნობილია ასეთი გამოუსადეგარობის ან შეუსაბამობის შესახებ.
            </Text> 
  
            <Text style={styles.p}>
                მზღვეველი არ მიიჩნევს ხომალდის ნაოსნობისათვის გამოსადეგობის და შესაბამისობის პირობის დარღვევად არც ერთ შემთხვევას, გარდა იმ შემთხვევებისა, როცა დაზღვეულისათვის ან მისი მომსახურე პერსონალისათვის ცნობილი იყო ასეთი გამოუსადეგარობისა და შეუსაბამობის შესახებ
            </Text> 
      
           
   
      
           
 
            

            <View style={{fontFamily: 'HelveticaBold', textAlign: 'right', marginBottom: '5px', marginTop: '270px',}}>
                <Text>დანართი N2</Text> 
            </View>
 
            <View style={{fontFamily: 'HelveticaBold', textAlign: 'center', marginBottom: '5px', marginTop: '20px'}}>
                <Text>სადაზღვევო შემთხვევის დაფიქსირების ინსტრუქცია</Text> 
            </View>


            <Text style={styles.p}>
                იმისათვის, რომ მოხდეს სადაზღვევო შემთხვევის, პოლისით განსაზღვრული დაზიანების ანაზღაურება აუცილებელია დაკმაყოფილდეს შემდეგი პირობები:
            </Text> 

            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>1.</Text><Text style={{textAlign: 'justify', }}>ნებისმიერ შემთხვევაში სადაზღვევო შემთხვევის დაფიქსირება უნდა მოხდეს ავტოსატრანსპორტო საშუალების პორტის ტერიტორიიდან გაყვანამდე. სადაზღვევო შემთხვევის შესახებ ინფორმაცია დაუყოვნებლივ და სრულად უნდა მიეწოდოს კომპანიის შესაბამის სამსახურს, ქვემოთ მითითებულ საკონტაქტო ნომრებზე.</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>2.</Text><Text style={{textAlign: 'justify', }}>სადაზღვევო პირობებით განსაზღვრული დაზიანების არსებობის შემთხვევაში ავტოსატრანსპორტო საშუალების პორტის ტერიტორიიდან გაყვანამდე, ასევე უნდა მოხდეს პორტის ადმინისტრაციაში აღნიშნულ ფაქტთან დაკავშირებით შესაბამისი სატერმინალო დაზიანების აქტის შედგენა და სატრანსპორტო საშუალების დასურათება.</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>3.</Text><Text style={{textAlign: 'justify', }}>ავტოსატრანსპორტო საშუალებაში მოთავსებული ნივთის, სათადარიგო საბურავის, ავტონაწილის ან/და გასაღების დაკარგვის/მოპარვის შემთხვევაში, ავტოსატრანსპორტო საშუალების პორტის ტერიტორიიდან გაყვანამდე, აუცილებელია მოხდეს საპატრულო პოლიციის გამოძხება ადგილზე აღნიშნული ფაქტის დასაფიქსირებლად.</Text></View>


                <View style={{ width: '100%', marginBottom: 10, marginTop: 30}}>
                    <Text style={{ fontFamily: 'HelveticaBold' }}>ცხელი ხაზი: </Text>
                    <Text>032(2) 11 55 22</Text>
                   
                </View>
  
                <View style={{ width: '100%', marginBottom: 10}}>
                    <Text style={{ fontFamily: 'HelveticaBold' }}>საკონტაქტო პირი ფოთში: </Text>
                    <Text>ლევან კარანაძე, ტელ: (+995) 577 39 60 60</Text>
                </View>
  
                {/* <View style={{ width: '100%', marginBottom: 10}}>
                    <Text style={{ fontFamily: 'HelveticaBold' }}>საკონტაქტო პირი ბათუმში: </Text> 
                    <Text>მარიამ აქულაშვილი, ტელ: (+995) 591 29 60 60</Text>
                </View> */}



        </Page>
 
    </Document>
);

const InsuranceSupplement = ({ carItem }) => {
    const {t} = useTranslation();
  
    const generatePDF = async () => {
        const blob = await pdf(<MyDocument car={carItem} />).toBlob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        // link.download = 'InsuranceSupplement.pdf';
        link.click();
    };

    return (
        <span className={cl.btn} onClick={generatePDF}><PDFicon />{t('InsuranceSupplement')}</span>
    );
};

export default InsuranceSupplement;
